import React from 'react'
import { connect } from 'react-redux'

import { Button } from '@bikemap/components'
import { gettext } from '../../../../services'
import { resetFilters } from '../../actions'
import { areFiltersDefault } from '../../helpers'

const t = {
    NO_ROUTES_HEADING: gettext('No routes found 😔'),
    NO_ROUTES_TEXT: gettext("There aren't any routes matching your search criteria. Try adjusting your filters or search for another route title."),
    RESET: gettext('Reset Search'),
}

const NoResultsMessage = ({ filtersChanged, onReset }) => (
    <div className="no-results text-center">
        <h3>{t.NO_ROUTES_HEADING}</h3>
        <p>{t.NO_ROUTES_TEXT}</p>
        {filtersChanged && <Button onClick={onReset} variant="primary">{t.RESET}</Button>}
    </div>
)

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ filters }) => ({
    filtersChanged: !areFiltersDefault(filters),
})

const mapDispatchToProps = dispatch => ({
    onReset: () => dispatch(resetFilters()),
})

export default connect(mapStateToProps, mapDispatchToProps)(NoResultsMessage)
